package com.karawek.core.ui.haptics

import androidx.compose.runtime.compositionLocalOf

// Core defaults to OFF; app enables explicitly
val LocalHapticsEnabled = compositionLocalOf { false }